import { getDarkenColor, hexToRgbA, getLightenColor } from './'
export default (type, colors) => {
  const styles = {
    default: {
      'modal-close': {
        boxShadow: `1px 1px 0 0 ${getLightenColor(colors.primary, 2)}`,
        customCSS: `
          .modal-close {
            color: ${colors.primary};
            background-color: ${colors.secondary};
          }
          .modal-close:hover,
          .modal-close:focus {
            background-color: ${getDarkenColor(getLightenColor(colors.primary, 2), 0.05)};
          }
        `
      },
      'modal': {
        customCSS: `
          .ReactModal__Content {
            box-shadow: 5px 5px 0 0 ${getDarkenColor(colors.primary, 0.17)};
          }
          .ReactModal__Overlay{
            background-color: ${hexToRgbA(getDarkenColor(colors.light, 0.026), 0.8)}!important;
         }
        `
      },
      'modal-show-more': {
        boxShadow: `1px 1px 0 0 ${getLightenColor(colors.primary, 2)}`,
        color: colors.primary,
        customCSS: `
          .modal-show-more {
            background-color: ${colors.secondary};
          }
          .modal-show-more:hover,
          .modal-show-more:focus {
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
          }
        `
      }
    },
    type1: {
      'modal': {
        customCSS: `
          .ReactModal__Content {
            box-shadow: none;
            box-shadow: 0px 1px 11px ${hexToRgbA('#000', 0.07)};
          }
          .ReactModal__Overlay {
            background-color: ${hexToRgbA('#000', 0.8)}!important;
          }
        `
      },
      'modal-close': {
        backgroundColor:'transparent',
        boxShadow: 'none',
        border: 'none',
        top: '1em',
        right: '1em',
        customCSS: `
          .modal-close {
            color: #C4C4C4;
          }
          .modal-close:hover,
          .modal-close:focus {
            color: ${getDarkenColor('#C4C4C4', 0.2)};
          }
        `
      },
      'modal-inner': {
        padding: '4em',
        maxHeight: '95vh'
      },
      'modal-show-more': {
        boxShadow: `none`,
        color: colors.primary,
        customCSS: `
          .modal-show-more {
            background-color: ${colors.secondary};
          }
          .modal-show-more:hover,
          .modal-show-more:focus {
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/modal.js